import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const SearchAreaWrapper = styled.div`
  padding: 5px 0px;
`;
export const SearchArea = styled.table`
  width: calc(100% - 10px);
  margin: 0px 5px;
  border-collapse: collapse;
  border: none;

  & td {
    padding: 0;
  }

  & td:last-child {
    border-top: 1px solid ${ColorSF2.mediumGray};
    border-right: 1px solid ${ColorSF2.mediumGray};
    border-bottom: 1px solid ${ColorSF2.mediumGray};
  }
`;
export const SearchOptionsTable = styled.table`
  width: 100%;
  align-items: center;
  flex-direction: column;
  border-collapse: collapse;

  & th {
    width: 120px;
    background-color: ${ColorSF2.lightGray};
    font-size: 12px;
    font-weight: 100;
  }
  & td {
    padding: 5px;
    font-size: 12px;
  }
  & tr {
    border: 1px solid ${ColorSF2.mediumGray};
  }
  & th,
  td {
    border: 1px solid ${ColorSF2.mediumGray};
  }
`;
export const DateTimeTd = styled.td`
  ${props => props.isGeneralUser && 'width: 30%'};
`;
export const InputDatetimeWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
`;
export const InputTitle = styled.div`
  flex: 0 0 auto;
`;
export const InputText = styled.input`
  width: 200px;
  @media (max-width: 830px), (max-height: 530px) {
    width: 160px;
    font-size: 12px;
  }
`;
export const ButtonWrapper = styled.div`
  padding: 8px;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
`;

export const TrFixedHeight = styled.tr`
  height: 40px;
`;
